module.exports = __webpack_public_path__ + "media/images/pages/about_us/partners/logo_region_na-ffc70a6ca11b5effd14db11d61f80d9f.png";